module.exports = __webpack_public_path__ + "static/12-47a89b327dae15b807011f9fbe579a85.jpg";